import React, { useEffect, useState } from 'react';
import Table, { MultiSelectFilter, includesOr } from './controls/Table';

function FinancesWithdrawals() {
  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const response = await fetch('api/finances/getwithdrawals');
      const data = await response.json();
      setData(data);
    } catch (error) {
      console.error(error);
    }
  };

  const withdrawalDetailsColumns = React.useMemo(
    () => [
      {
        Header: 'Symbol',
        accessor: 'withdrawal.symbol',
        Filter: MultiSelectFilter,
        filter: includesOr,
        Footer: '',
      },
      {
        Header: 'Lots',
        accessor: 'lots.length',
        Footer: '',
      },
      {
        Header: 'Date',
        accessor: 'withdrawal.date',
        Footer: '',
      },
      {
        Header: '',
        accessor: 'withdrawal.id',
        Footer: '',
      },
      {
        Header: 'Withdrawal Account',
        accessor: 'withdrawal.account.friendlyName',
        Filter: MultiSelectFilter,
        filter: includesOr,
        Footer: '',
      },
      {
        Header: 'Withdrawal Quantity',
        accessor: 'withdrawal.currentQuantity',
        Footer: '',
      },
      {
        Header: '',
        accessor: 'deposits',
        Cell: ({ row }) => row.original.deposits?.[0]?.id || '',
        Footer: '',
      },
      {
        Header: 'Deposit Account',
        accessor: row => row.deposits?.[0]?.account.friendlyName,
        Filter: MultiSelectFilter,
        filter: includesOr,
        Footer: '',
      },
      {
        Header: 'Deposit Quantity',
        accessor: row => row.deposits?.[0]?.currentQuantity ?? '',
        Footer: '',
      },
      {
        Header: 'Withdrawal Fee',
        accessor: 'withdrawalFee',
        Cell: ({ row }) => {
          const withdrawalFee = row.original.withdrawal?.currentQuantity + row.original.deposits?.[0]?.currentQuantity;
          return isNaN(withdrawalFee) ? null : <>{withdrawalFee}</>;
        },
        Footer: '',
      },
      {
        Header: 'Cost Basis',
        accessor: 'costBasis',
        Footer: '',
      },
    ],
    []
  );

  const withdrawalLotColumns = React.useMemo(
    () => [
      {
        Header: 'Id',
        accessor: 'id',
        Footer: '',
      },
      {
        Header: 'Account',
        accessor: 'account.friendlyName',
        Footer: '',
      },
      {
        Header: 'Date',
        accessor: 'date',
        Footer: '',
      },
      {
        Header: 'Type',
        accessor: 'type',
        Footer: '',
      },
      {
        Header: 'Symbol',
        accessor: 'symbol',
        Footer: '',
      },
      {
        Header: 'Original Quantity',
        accessor: 'originalQuantity',
        Footer: info => {
          const total = info.rows.reduce((sum, row) => row.values.originalQuantity + sum, 0);
          return <>{total.toFixed(8)}</>;
        },
      },
      {
        Header: 'Current Quantity',
        accessor: 'currentQuantity',
        Footer: info => {
          const total = info.rows.reduce((sum, row) => row.values.currentQuantity + sum, 0);
          return <>{total.toFixed(8)}</>;
        },
      },
      {
        Header: 'Original Basis',
        accessor: 'originalBasis',
        Footer: info => {
          const total = info.rows.reduce((sum, row) => row.values.originalBasis + sum, 0);
          return <>{total.toFixed(8)}</>;
        },
      },
      {
        Header: 'Current Basis',
        accessor: 'currentBasis',
        Footer: info => {
          const total = info.rows.reduce((sum, row) => row.values.currentBasis + sum, 0);
          return <>{total.toFixed(8)}</>;
        },
      },
      {
        Header: 'Price',
        accessor: 'price',
        Cell: ({ row }) => {
          const price = Math.abs(row.original.currentBasis / row.original.currentQuantity);
          return <>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price)}</>;
        },
        Footer: '',
      },
      {
        Header: 'FeesUSD',
        accessor: 'feesUSD',
        Footer: info => {
          const total = info.rows.reduce((sum, row) => {
            return sum + (row.original.feesUSD || 0);
          }, 0);
          return <>{total.toFixed(8)}</>;
        },
      },
      {
        Header: 'Crypto Fee',
        accessor: 'cryptoFee',
        Footer: info => {
          const total = info.rows.reduce((sum, row) => {
            return sum + (row.original.cryptoFee || 0);
          }, 0);
          return <>{total.toFixed(8)}</>;
        },
      },
    ],
    []
  );

  const getNestedData = (row) => {
    return row.original.lots || [];
  };

  return (
    <div>
      <div>
        <h2>Withdrawals ({data?.length})</h2>
        <br></br>
        <div>
          <Table
            columns={withdrawalDetailsColumns}
            data={data}
            nestedColumns={withdrawalLotColumns}
            getNestedData={getNestedData}>
          </Table>
        </div>
      </div>
    </div>
  );
}

export default FinancesWithdrawals;